import { toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5ecdc21d")

_pushScopeId("data-v-5ecdc21d")
const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "fal fa-times" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return (_openBlock(), _createBlock("section", null, [
    (_ctx.showSnackbar)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          ref: "snackbar",
          class: ["snackbar", [_ctx.statusType, _ctx.showSnackbar ? 'show' : '']]
        }, [
          _createVNode("p", null, _toDisplayString(_ctx.message), 1),
          _createVNode("span", {
            class: "close",
            onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.close()), ["prevent","stop"])),
            title: "Dismiss"
          }, [
            _hoisted_1
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
})